import { useEffect, useRef, useState } from "react";

let turnstileLoaderPromise = null;

function loadTurnstile() {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }

  if (turnstileLoaderPromise) {
    return turnstileLoaderPromise;
  }

  turnstileLoaderPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById("cf-turnstile-script");

    const handleReady = () => {
      if (window.turnstile) {
        resolve(window.turnstile);
      } else {
        reject(new Error("Turnstile non disponibile."));
      }
    };

    if (existing) {
      existing.addEventListener("load", handleReady, { once: true });
      existing.addEventListener(
        "error",
        () => reject(new Error("Impossibile caricare Turnstile.")),
        { once: true }
      );
      return;
    }

    const script = document.createElement("script");
    script.id = "cf-turnstile-script";
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.addEventListener("load", handleReady, { once: true });
    script.addEventListener(
      "error",
      () => reject(new Error("Impossibile caricare Turnstile.")),
      { once: true }
    );
    document.head.appendChild(script);
  });

  return turnstileLoaderPromise;
}

export default function TurnstileWidget({ onToken }) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const [error, setError] = useState("");
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

  useEffect(() => {
    let cancelled = false;

    if (!siteKey) {
      setError("Verifica anti-spam non configurata.");
      onToken("");
      return undefined;
    }

    loadTurnstile()
      .then((turnstile) => {
        if (cancelled || !containerRef.current) return;

        widgetIdRef.current = turnstile.render(containerRef.current, {
          sitekey: siteKey,
          theme: "light",
          size: "normal",
          appearance: "interaction-only",
          action: "lead_submit",
          callback: (token) => {
            setError("");
            onToken(token);
          },
          "expired-callback": () => onToken(""),
          "timeout-callback": () => onToken(""),
          "error-callback": () => {
            setError("Verifica anti-spam non disponibile. Riprova.");
            onToken("");
          },
        });
      })
      .catch(() => {
        if (!cancelled) {
          setError("Verifica anti-spam non disponibile. Riprova.");
          onToken("");
        }
      });

    return () => {
      cancelled = true;
      if (window.turnstile && widgetIdRef.current !== null) {
        try {
          window.turnstile.remove(widgetIdRef.current);
        } catch (_) {
          // The widget may already have been removed by Turnstile.
        }
      }
    };
  }, [onToken, siteKey]);

  return (
    <div className="turnstile-wrap">
      <div ref={containerRef} className="turnstile-widget" />
      {error && <p className="turnstile-error" role="alert">{error}</p>}
    </div>
  );
}
